import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { resetOrder } from '../../actions/currentOrder';

const initialState = null as Pick<
  DeliveryAddress,
  'buildingInformation' | 'deliveryInstruction'
> | null;

const slice = createSlice({
  name: '$deliveryDetails',
  initialState,
  reducers: {
    setDeliveryDetails(
      state,
      action: PayloadAction<
        Pick<DeliveryAddress, 'buildingInformation' | 'deliveryInstruction'>
      >,
    ) {
      return action.payload;
    },
  },
  extraReducers: builder => {
    builder.addCase(resetOrder, (_state, _action) => {
      return initialState;
    });
  },
});

export const { setDeliveryDetails } = slice.actions;
export default slice.reducer;
